export const Date = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="none">
    <path
      d="M20.1 7.5H3.9C3.40294 7.5 3 7.88802 3 8.36667V19.6333C3 20.112 3.40294 20.5 3.9 20.5H20.1C20.5971 20.5 21 20.112 21 19.6333V8.36667C21 7.88802 20.5971 7.5 20.1 7.5Z"
      stroke="currentColor"
      stroke-width="1.375"
    />
    <path d="M7 4.5V7.5" stroke="currentColor" stroke-width="1.375" />
    <path d="M12.5 12.5H7" stroke="currentColor" stroke-width="1.375" />
    <path d="M17 16.5H7" stroke="currentColor" stroke-width="1.375" />
    <path d="M17 4.5V7.5" stroke="currentColor" stroke-width="1.375" />
  </svg>
);
export const ASC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 23" fill="none">
    <path d="M10.542 4.16602H19.7087" stroke="currentColor" stroke-width="1.375" />
    <path d="M6.41667 19.2917L2.75 15.625" stroke="currentColor" stroke-width="1.375" />
    <path d="M6.41699 3.70898V19.2923" stroke="currentColor" stroke-width="1.375" />
    <path d="M10.542 8.75H17.8753" stroke="currentColor" stroke-width="1.375" />
    <path d="M10.542 13.334H16.042" stroke="currentColor" stroke-width="1.375" />
    <path d="M10.542 17.916H14.2087" stroke="currentColor" stroke-width="1.375" />
  </svg>
);

export const DESC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
    <path d="M10.542 4.625H19.7087" stroke="currentColor" stroke-width="1.375" />
    <path d="M2.29199 7.83268L5.95866 4.16602" stroke="currentColor" stroke-width="1.375" />
    <path d="M5.95801 4.16602V19.7493" stroke="currentColor" stroke-width="1.375" />
    <path d="M10.542 9.20898H17.8753" stroke="currentColor" stroke-width="1.375" />
    <path d="M10.542 13.791H16.042" stroke="currentColor" stroke-width="1.375" />
    <path d="M10.542 18.375H14.2087" stroke="currentColor" stroke-width="1.375" />
  </svg>
);

export const Popularity = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="none">
    <path
      d="M12 20.5C15.2939 20.5 18 17.8897 18 14.5392C18 13.7167 17.9582 12.835 17.5023 11.4646C17.0464 10.0943 16.9545 9.91744 16.4724 9.07116C16.2665 10.7982 15.1645 11.5179 14.8845 11.733C14.8845 11.5092 14.2179 9.03436 13.2071 7.55356C12.2148 6.1 10.8654 5.14637 10.0741 4.5C10.0741 5.72791 9.72878 7.55356 9.23418 8.48376C8.73958 9.41396 8.6467 9.44784 8.02889 10.1401C7.41113 10.8323 7.12757 11.0461 6.61096 11.886C6.09438 12.726 6 13.8447 6 14.6672C6 18.0177 8.70614 20.5 12 20.5Z"
      stroke="currentColor"
      stroke-width="1.375"
    />
  </svg>
);

export const Alert = () => (
  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.22183 4.72182C6.21136 2.73232 8.96273 1.5 12 1.5C15.0373 1.5 17.7886 2.73231 19.7782 4.72182C21.7677 6.71135 23 9.46273 23 12.5C23 15.5373 21.7677 18.2886 19.7782 20.2782C17.7886 22.2677 15.0373 23.5 12 23.5C8.96273 23.5 6.21136 22.2677 4.22183 20.2782C2.23232 18.2886 1 15.5373 1 12.5C1 9.46273 2.23233 6.71135 4.22183 4.72182ZM12 5.5C11.4477 5.5 11 5.94772 11 6.5V14.5C11 15.0523 11.4477 15.5 12 15.5C12.5523 15.5 13 15.0523 13 14.5V6.5C13 5.94772 12.5523 5.5 12 5.5ZM12 19C12.6903 19 13.25 18.4403 13.25 17.75C13.25 17.0597 12.6903 16.5 12 16.5C11.3097 16.5 10.75 17.0597 10.75 17.75C10.75 18.4403 11.3097 19 12 19Z"
      fill="#0F5EF7"
    />
  </svg>
);
